<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="brand">
              <h1>Unidad de Cómputo y Supercómputo</h1>
              <h3>Instituto de Ciencias de la Atmósfera y Cambio Climático</h3>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container">
          <div class="title_seccion">
            <h2 >Infraestructura</h2>
          </div>
          <infrastructure></infrastructure>
        </div>
      </div>
    </div>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container">
          <div class="title_seccion"  >
            <h2 id="servicesSection"  >Servicios </h2>
          </div>
          <services></services>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Infrastructure from "./components/Infrastructure";
import Services from '@/views/components/Services';

export default {
  components: {
    Infrastructure,
    Services
  },
  name: "index",
  bodyClass: "index-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/vue-mk-header.jpg")
    }
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
      leafShow: false
    };
  },
  methods: {
    leafActive() {
      if (window.innerWidth < 768) {
        this.leafShow = false;
      } else {
        this.leafShow = true;
      }
    },
    scrollToElement(element) {
      let element_id = document.getElementById(element);
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`
      };
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
